import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { image } from './../../../Helpers';

import './type-four.css';

/**
 * Type four
 *
 * @class TypeFour
 * @extends {Component}
 */
class TypeFour extends Component {
  /**
   * render
   *
   * @returns JSX
   * @memberof TypeFour
   */
  render() {
    return (
      <div className="history-type-four x-large">
        <div className="wrapper">
          {image(this.props.titulo, this.props.imagem)}

          {this.props.getInfo &&
            <div className="content">
              {this.props.getInfo(this.props.titulo, this.props.descricao)}
            </div>}
        </div>
      </div>
    )
  }
}

TypeFour.propTypes = {
  titulo: PropTypes.string.isRequired,
  imagem: PropTypes.object.isRequired,
  getInfo: PropTypes.func.isRequired,
  descricao: PropTypes.string,
}

export default TypeFour;